// extracted by mini-css-extract-plugin
module.exports = {"Author_wrapper":"AuthorInfo_Author_wrapper__1lADT"};